/* Polsk katalog for locale-journal-recovery-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'journalRecovery.title': 'Księgowość jest tymczasowo niedostępna',
  'journalRecovery.description': 'Nie udało się zweryfikować dziennika. Strony księgowe i zmiany są zablokowane, dopóki weryfikacja się nie powiedzie. Możesz skontaktować się z pomocą techniczną lub zmienić firmę w menu.',
  'journalRecovery.reference': 'Firma: {businessId} · Rok obrotowy: {year}',
  'journalRecovery.retry': 'Spróbuj ponownie',
  'journalRecovery.retrying': 'Sprawdzanie …',
  'journalRecovery.support': 'Skontaktuj się z pomocą techniczną',
  'journalRecovery.signOut': 'Wyloguj',
  'journalRecovery.writeBlocked': 'Dziennik jest niedostępny. Spróbuj ponownie, zanim zmienisz dane księgowe.',
});
